import type {Mapper} from 'framework';
import type {LogSetResult, WorkoutSet, WorkoutSetPrefill} from '../../domain/workout';
import type {LogSetDto} from '../dto/workout.dto';
import type {WorkoutDtoToWorkoutMapper} from './workout-dto-to-workout.mapper';

export class LogSetDtoToLogSetResultMapper implements Mapper<LogSetDto, LogSetResult> {
  constructor(private readonly workoutMapper: WorkoutDtoToWorkoutMapper) {}

  transform(dto: LogSetDto): LogSetResult {
    const set: WorkoutSet = {
      id: dto.set.id,
      setNumber: dto.set.setNumber,
      weightKg: dto.set.weightKg,
      reps: dto.set.reps,
      rpe: dto.set.rpe,
      isWarmup: dto.set.isWarmup,
      isDropset: dto.set.isDropset,
      isFailure: dto.set.isFailure,
      notes: dto.set.notes,
      startedAt: dto.set.startedAt !== null ? String(dto.set.startedAt) : null,
      completedAt: dto.set.completedAt !== null ? String(dto.set.completedAt) : null,
    };

    const nextPrefill: WorkoutSetPrefill | null =
      dto.nextPrefill === null
        ? null
        : {
            workoutExerciseId: dto.nextPrefill.workoutExerciseId,
            setNumber: dto.nextPrefill.setNumber,
            weightKg: dto.nextPrefill.weightKg,
            reps: dto.nextPrefill.reps,
          };

    return {
      workout: this.workoutMapper.transform(dto.workout),
      set,
      workoutExerciseId: dto.workoutExerciseId,
      nextPrefill,
      restSeconds: dto.restSeconds,
      personalRecords: dto.personalRecords.map(hit => ({
        exerciseId: hit.exerciseId,
        kind: hit.kind,
        value: hit.value,
        reps: hit.reps,
      })),
    };
  }
}
